import { Box, Flex } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { useState } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import classes from './AskSiestaInput.module.css';

type Props = {
  variant?: 'light' | 'brand';
  onSubmit?: (message: string) => void;
  onFocus?: () => void;
  autoFocus?: boolean;
  disabled?: boolean;
  submitDisabled?: boolean;
};

export function AskSiestaInput({
  variant = 'light',
  onSubmit,
  onFocus,
  autoFocus,
  disabled,
  submitDisabled,
}: Props) {
  const [value, setValue] = useState('');
  const borderColor = variant === 'light' ? 'orange-1' : 'orange-6';
  const colorVar = `var(--mantine-color-${borderColor})`;

  const canSubmit = !disabled && !submitDisabled;

  const handleSubmit = () => {
    if (canSubmit && value.trim() && onSubmit) {
      onSubmit(value.trim());
      setValue('');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Box
      px="lg"
      h={52}
      w="100%"
      style={{
        borderRadius: 'var(--mantine-radius-xl)',
        border: `4px solid ${colorVar}`,
        background: 'transparent',
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <Flex align="center" h="100%" gap="xs">
        <input
          type="text"
          placeholder="Ask me anything"
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          onFocus={onFocus}
          autoFocus={autoFocus}
          disabled={disabled}
          className={classes.input}
          style={{
            flex: 1,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            color: colorVar,
            fontSize: 'var(--mantine-font-size-textMd)',
            fontWeight: FONT_WEIGHTS.medium,
            fontFamily: 'inherit',
          }}
        />
        <button
          type="button"
          onClick={handleSubmit}
          disabled={!canSubmit || !value.trim()}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: canSubmit && value.trim() ? 'pointer' : 'default',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconPlus size={24} color={colorVar} />
        </button>
      </Flex>
    </Box>
  );
}
